import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, BUSINESS } from "@/data";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-ink/85 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        <a href="#top" onClick={(e) => { e.preventDefault(); scrollTo("#top"); }} className="flex items-center" data-testid="nav-logo">
          <img src={LOGO_URL} alt={BUSINESS.name} className="h-14 w-14 object-contain" />
          <span className="ml-2 hidden sm:block font-display font-extrabold text-white tracking-tight text-lg leading-none">
            CLEAR<span className="text-brand">CO</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              onClick={() => scrollTo(l.href)}
              className="text-sm font-medium text-slate-300 hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a href={BUSINESS.phoneHref} className="flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors" data-testid="nav-phone-link">
            <Phone size={16} strokeWidth={1.5} /> {BUSINESS.phone}
          </a>
          <button
            data-testid="nav-quote-button"
            onClick={() => scrollTo("#quote")}
            className="rounded-xl bg-brand hover:bg-brand-hover text-white font-semibold text-sm px-5 py-2.5 transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-brand/25"
          >
            Get a Quote
          </button>
        </div>

        <button data-testid="nav-mobile-toggle" className="md:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-ink border-t border-white/10 px-6 py-6 space-y-4">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-${l.label.toLowerCase()}-link`}
              onClick={() => scrollTo(l.href)}
              className="block w-full text-left text-slate-200 py-2 font-medium"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-quote-button"
            onClick={() => scrollTo("#quote")}
            className="w-full rounded-xl bg-brand text-white font-semibold px-5 py-3 mt-2"
          >
            Get a Quote
          </button>
        </div>
      )}
    </header>
  );
};
